import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = false, roles = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.must_change_password && location.pathname !== "/cambiar-password") {
    return <Navigate to="/cambiar-password" replace />;
  }

  const homeFor = (rol) => (rol === "agencia" ? "/portal" : "/");

  if (requireAdmin && user.rol !== "admin") {
    return <Navigate to={homeFor(user.rol)} replace />;
  }

  if (roles && !roles.includes(user.rol)) {
    return <Navigate to={homeFor(user.rol)} replace />;
  }

  return children;
}
